<page-error-state *ngIf="!isLoading" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission('READ')" pageName="Order_Management"></page-error-state>
<div *ngIf="hasPermission('READ') && !noPMLicense" class="order-management-container container-fluid cx-one-ui">
  <!-- HEADERS -->
  <div class="row justify-content-between">
    <div class="col-12 d-flex justify-content-between">
      <div class="font-size-18 order-management-title" cvLocalizedText langSection="Order_Management"
        langKey="OrderManagement">Order
        Management</div>
      <button class="btn cxone-btn btn-big btn-secondary btn-bg-is-white export-btn" tabindex="0" (click)="exportOrdersTable()">
        <svg>
          <use href="../App_Themes/CXone/icons/export.svg#export"></use>
        </svg>
        <span cvLocalizedText langSection="Module_Menu" langKey="Export">Export</span>
      </button>
    </div>
  </div>
  <!-- /HEADERS -->
  <!-- MAIN CONTAINER -->
  <div class="row">
    <div class="col-12">
      <!-- BG COLOR CONTAINER -->
      <div class="container-shadow">
        <!-- FILTER -->
        <!-- omnibar and search bar -->
        <sol-omnibar #filters class="w-100 order-managment-omnibar" [itemCountLabel]="countOrdersLabel"
          [isFilterable]="true" [searchPlaceholderText]="searchPlaceholder"
          (showFooterChanged)="isFilterOpen = !isFilterOpen"
          (searchQueryChange)="onTitleFilterChange($event)">
          <sol-omnibar-custom-content
            class="d-flex justify-content-between w-100 align-items-center">
            <div class="d-flex align-items-center w-100">
              <sol-selected-tags id="selected-status-tags" label="name" class="w-77" [removable]="true"
              [tagsSource]="tagList" primaryKey="id" (tagDeleted)="removeTag($any($event))" />
              <!-- <a class="pr-1" *ngIf="tagList.length > 0" cvLocalizedText langSection="MarketPlace_Management" langKey="Clear_All"
                  (click)="clearFilters()">Clear All</a> -->
            </div>
            <sol-dropdown id="orders-placed-in-dropdown" 
              class="d-block drodpdown-container-timeinterval"
              [optionsLabel]="'name'" [optionsValue]="'position'" 
              [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Placeholder_Dropdown_Menu', 'Select items')" 
              [(ngModel)]="datePosition"
              [options]="pspos.pointStoreProductAdminOrderFilter.dateCXOne"
              (selectionChange)="selectionChangedDatePosition();clearFilters()"
              >
            </sol-dropdown>
          </sol-omnibar-custom-content>
          <!-- filters -->
          <sol-omnibar-filters>
            <div id="filters-container" class="d-flex justify-content-between bg-light-blue-2 flex-wrap">
              <div class="d-flex flex-wrap">
                <div class="d-block text-start pr-4">
                  <label class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 " cvLocalizedText
                    langSection="Order_Management" langKey="Status">Status</label>
                  <sol-dropdown #statusDropdown
                    id="status-dropdown" 
                    [optionsLabel]="'name'" class="d-block drodpdown-container"
                    [optionsValue]="'value'"
                    [searchEnabled]="false"
                    [showFooter]="false"
                    [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Select_Item', 'Select...')"
                    [(ngModel)]="selectedStatus"
                    [options]="orderStatusList.newValue"
                    (selectionChange)="selectionChangedStatus()"
                    >
                  </sol-dropdown>
                </div>
                <!-- <cv-group-selector #groupSelectorDTOComp 
                  [pageName]="'PointStoreAdmin_temp'" 
                  [baseGroupType]="0"
                  [removeTopLevel]="true" 
                  [hasMultiSelect]="true" 
                  [selectedGroupsDto]="selectedAgentsDTO"
                  (selectedGroupsChanged)="onEmpGroupsChanged($event)" 
                  [ariaPlaceholder]="cvLocalizationService.getCachedText('Order_Management', 'Placeholder_Dropdown_Menu', 'Select...')"
                  (selectedGroupsLoaded)="initialGroupsLoaded($event)" 
                  direction="horizontal">
                </cv-group-selector> -->
                <div class="d-block text-start pr-4">
                  <label class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 " cvLocalizedText
                    langSection="Order_Management" langKey="Team_Label">Team</label>
                  <sol-dropdown id="team-dropdown" [optionsLabel]="'name'" class="d-block drodpdown-container"
                    [optionsValue]="'id'" [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Select_Item', 'Select...')" [(ngModel)]="selectedTeam"
                    [options]="teamList.newValue" (selectionChange)="selectionChangedTeam()" >
                  </sol-dropdown>
                </div>
                <div class="d-block text-start pr-4">
                  <label class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 " cvLocalizedText
                    langSection="Order_Management" langKey="Agent_Label">Agent</label>
                  <sol-dropdown #agentDropdown id="agent-dropdown" [optionsLabel]="'name'" class="d-block drodpdown-container"
                    [optionsValue]="'loginId'" [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Select_Item', 'Select...')" [(ngModel)]="selectedAgent" [options]="agentList.newValue" (selectionChange)="selectionChangedAgent()"
                    >
                  </sol-dropdown>
                </div>
              </div>
              <div class="action-btns d-flex align-items-center justify-content-md-end justify-content-lg-end pr-4">
                <a class="pr-2" cvLocalizedText langSection="Order_Management" langKey="Clear_All"
                  (click)="clearFilters()">Clear All</a>
                <a class="pl-2" cvLocalizedText langSection="Order_Management" langKey="Close"
                  (click)="closeFilters()">Close</a>
              </div>
            </div>
          </sol-omnibar-filters>
          <!-- end filters -->
        </sol-omnibar>
        <!-- end omnibar and search bar -->
        <!-- /FILTER -->
        <!-- GRID -->
        <div class="mx-auto " 
        [ngClass]="{ 
          'order-management-table-container': !isFilterOpen,
          'order-management-table-container-filters': isFilterOpen,
        }">
          <!-- COMPONENT  -->
          <cxone-order-management-grid (countOrders)="setCountOrdersLabel($event)" [ordersList]="pspos.adminOrders"
            [status]="pspos.pointStoreProductAdminOrderFilter.SelectedStatuses"
            [timeInterval]="pspos.pointStoreProductAdminOrderFilter.datePosition"
            [search]="pspos.pointStoreProductAdminOrderFilter.searchOrder"
            [ordersLoading]="pspos.ordersLoading"
            [selectGroupChange]="pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged"
            [resetFilter]="pspos.pointStoreProductAdminOrderFilter.resetFilter"
            [groupSelectorEmtpy]="pspos.pointStoreProductAdminOrderFilter.groupSelectorEmtpy"
            (groupSelectorData)="setGroupSelectorData($event)">
          </cxone-order-management-grid>
        </div>
        <!-- /GRID -->
      </div>
      <!-- /BG COLOR CONTAINER -->
    </div>
  </div>
  <!-- /MAIN CONTAINER -->
</div>